<div class="search-box">
    <label
        (click)="changeSearchText(searchInput)"
        id="default-text-label"
        class="list-item__text"
        >{{ dialogHeader }}</label
    >
    <mat-icon
        tabindex="0"
        class="searching-icon"
        fontSet="fa"
        fontIcon="fa-search"
        aria-hidden="true"
        *ngIf="!searchActive"
        (click)="changeSearchText(searchInput)"
    ></mat-icon>
    <mat-icon
        tabindex="0"
        class="times-icon"
        fontSet="fa"
        fontIcon="fa-times"
        aria-hidden="true"
        *ngIf="searchActive"
        (click)="changeSearchText(searchInput)"
    ></mat-icon>
    <input
        class="text-field__input"
        id="search-input"
        #searchInput
        type="text"
        placeholder=""
        aria-hidden="true"
        [(ngModel)]="searchTerm"
    />
</div>
